import DepositSettlementWrapper from "@/modules/savings/deposit-settlement/DepositSettlementWrapper";
import React from "react";

const DepositSettlementPage: React.FC = () => {
  return <DepositSettlementWrapper />;
};

export default DepositSettlementPage;
